import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionFundBillAdjustmentCustomer = () => {
  const listCustomer = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest(
      '/transaction/fund-bill-adjustment/list-customer',
      payload,
      (response) => {
        loading(false)
        if (response.code === 7200) {
          callback(response.data)
        } else {
          callback(null)
        }
      },
    )
  }, [])
  return { listCustomer }
}

export default InteractorTransactionFundBillAdjustmentCustomer
